module.exports = function() {
  return new Worker(__webpack_public_path__ + "489d837a761a91a98598.worker.js");
};